import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { setMapCenter } from 'shared/map/model/slice';
import { clearEventOnMap } from 'console/redux/main-actions';
import { a2l } from 'shared/map/lib/utils';
import { InfoBox } from 'shared/map/ui/components/infobox';
export const DeviceEventOnMap = memo(function DeviceEventOnMap(props) {
    const { device_id } = props;
    const event_on_map = useAppSelector((state) => state.event_on_map);
    const onSetMapCenter = useAction(setMapCenter);
    const onClearEventOnMap = useAction(clearEventOnMap);
    //Когда выбираем иконку с остановкой, будем центрироваться на неё
    useEffect(() => {
        if (event_on_map != null) {
            onSetMapCenter({ center: event_on_map.loc(), device_id });
        }
    }, [event_on_map, device_id]);
    if (!event_on_map) {
        return null;
    }
    return (_jsx(InfoBox, { position: a2l(event_on_map.loc()), unsafe_html_content: event_on_map.generateInfoBoxContent(), onClose: onClearEventOnMap }));
});
